import SortingControl from "app/containers/Features/components/SortingControl";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectBoardsShorting,
  selectDraftBoardForm,
} from "../Settings/redux/selector";
import { actions as boardSettingsActions } from "../Settings/redux/slice";
import { boardsTicketShortFields } from "../Settings/redux/data";
import { initialFiltersValues } from "../Settings/redux/initialState";
import { SortRule } from "app/containers/Features/components/SortingControl/types";
import { sortOrder } from "app/types";

const normalizeSortRules = (rules: SortRule[]) => {
  const cleaned = rules.filter((rule) => rule.fieldKey !== null);

  if (cleaned.length === 0) {
    return [];
  }

  const lastRule = cleaned[cleaned.length - 1];
  if (lastRule.fieldKey !== null) {
    return [...cleaned, { fieldKey: null, order: sortOrder.ASC }];
  }

  return cleaned;
};

const Sort = () => {
  const dispatch = useDispatch();
  const boardDraftForm = useSelector(selectDraftBoardForm);
  const boardsShorting = useSelector(selectBoardsShorting);
  const filters = boardDraftForm.filters ?? initialFiltersValues;
  const rules = filters.sort || [];

  const updateRules = (updater: (prevRules: SortRule[]) => SortRule[]) => {
    const nextRules = normalizeSortRules(updater(rules));
    dispatch(
      boardSettingsActions.setDraftBoardFormData({
        ...boardDraftForm,
        filters: {
          ...filters,
          sort: nextRules,
        },
      }),
    );
  };

  return (
    <SortingControl
      fields={boardsTicketShortFields}
      rules={rules}
      draggedIndex={boardsShorting.draggedIndex}
      onAddRule={(fieldKey: string) =>
        updateRules((prevRules) => [
          ...prevRules,
          { fieldKey, order: sortOrder.ASC },
        ])
      }
      onRemoveRule={(index: number) =>
        updateRules((prevRules) => prevRules.filter((_, i) => i !== index))
      }
      onUpdateField={(index: number, fieldKey: string | null) =>
        updateRules((prevRules) =>
          prevRules.map((rule, i) =>
            i === index ? { ...rule, fieldKey } : rule,
          ),
        )
      }
      onUpdateOrder={(index: number, order: sortOrder) =>
        updateRules((prevRules) =>
          prevRules.map((rule, i) =>
            i === index ? { ...rule, order } : rule,
          ),
        )
      }
      onReorder={(from: number, to: number) =>
        updateRules((prevRules) => {
          const nextRules = [...prevRules];
          const [moved] = nextRules.splice(from, 1);
          nextRules.splice(to, 0, moved);
          return nextRules;
        })
      }
      onClearRules={() =>
        dispatch(
          boardSettingsActions.setDraftBoardFormData({
            ...boardDraftForm,
            filters: {
              ...filters,
              sort: [],
            },
          }),
        )
      }
      onUpdateDraggedIndex={(index: number | null) =>
        dispatch(
          boardSettingsActions.setBoardsShorting({
            ...boardsShorting,
            draggedIndex: index,
          }),
        )
      }
    />
  );
};
export default Sort;
